var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m84.375 16.894-.01 23.731h-9.371L75 16.894c0-4.147-3.372-7.519-7.519-7.519H32.52c-4.147 0-7.519 3.372-7.519 7.519v23.731h-9.375V16.894C15.625 7.578 23.203 0 32.519 0H67.48c9.316 0 16.894 7.578 16.894 16.894zM54.263 73.647v7.51a3.907 3.907 0 1 1-7.816 0v-7.51a7.395 7.395 0 0 1-3.494-6.288c0-4.084 3.316-7.4 7.404-7.4a7.401 7.401 0 0 1 3.906 13.688zM12.5 46.875V100h65.537c5.229 0 9.463-4.581 9.463-10.228V46.875h-75z",
    fill: "#CF3524"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.eded1742a40d3dae27d5579abbfceee5.svg";
export { ForwardRef as ReactComponent };